import { extendObservable, runInAction } from 'mobx';

import { GlossaryController } from '../../../networking/controllers/GlossaryController';
import { Logger } from '../../../helpers/Logger';

class GlossaryStoreClass {
  constructor() {
    extendObservable(this, {
      definition: null,
      loading: false,
      error: false,
    });
  }

  async getDefinition(id) {
    runInAction(() => {
      this.definition = null;
      this.loading = true;
      this.error = false;
    });
    try {
      const definition = await GlossaryController.find(id);
      runInAction(() => {
        this.definition = definition;
      });
    } catch (error) {
      Logger.warn(error);
      runInAction(() => {
        this.error = true;
      });
    } finally {
      runInAction(() => {
        this.loading = false;
      });
    }
  }
}

const GlossaryStore = new GlossaryStoreClass();

export { GlossaryStore };



// WEBPACK FOOTER //
// ./src/common/glossary-entry/stores/GlossaryStore.js